<template>
  <div class="select-buildings" :class="{'select-buildings_danger': danger}">
    <label class="select-buildings__label vs-select--label">Дома</label>
    <div  class="select-buildings__text-wrapper">
      <div @click="isSelectHousePopupOpen = true"
           class="select-buildings__text"
           :class="{
           'select-buildings__text_empty': !valueX.length
         }"
      >
        {{housesText}}
      </div>
    </div>

    <transition name="fade">
      <div class="select-buildings__validation-error" v-if="danger && dangerText.length">
        {{dangerText}}
      </div>
    </transition>

    <vs-popup title="Выбор дома" :active.sync="isSelectHousePopupOpen">
      <v-tree :data="housesTree" ref="tree" :tpl="tpl" class="tree-actions-hover reports-house-tree"
              :topMustExpand="false" :multiple="true" :halfcheck="true" v-if="isShowTree" @node-check="onNodeCheck" @node-select="onNodeSelect"/>

      <div class="flex justify-center">
        <vs-button color="success" type="border" @click="acceptParametersHouses">Применить</vs-button>
      </div>

    </vs-popup>
  </div>
</template>

<script>
  const NODES_TYPES = {
    group: 0,
    house: 1,
  };

  import {VTree} from 'vue-tree-halower'
  import 'vue-tree-halower/dist/halower-tree.min.css'

  export default {
    name: "SelectBuildings",
    components: {VTree},
    props: {
      value: {},
      danger: {
        default: false,
        type: Boolean
      },
      dangerText: {
        default: "Выберите хотя бы один дом",
        type: String
      }
    },
    data() {
      return {
        isSelectHousePopupOpen: false,
        houses: [],
        allHouses: [],
        selectedHouses: [],
        isShowTree: true,
      }
    },
    computed: {
      valueX() {
        return this.value
      },
      housesText() {
        let houses = this.housesArray.filter(h => this.valueX.includes(h.id));
        return houses.length ? houses.map(house => house.address).join('; ') : 'Выберите дома';
      },
      housesArray(){
        let houses = [];

        let root = this.allHouses;
        let getChildren = (node) => {
          if (!node.children) node.children = [];
          if (Array.isArray(node.groups) && node.groups.length) {
            node.groups.forEach(nodeDepartment => {
              getChildren(nodeDepartment);
            });
          }
          if (Array.isArray(node.buildings) && node.buildings.length) {
            node.buildings.forEach(building => {
              houses.push(building);
            });
          }
        };
        getChildren(root);

        return houses;
      },
      housesTree() {
        let root = this.houses;
        root.nodeType = NODES_TYPES.group;
        root.expanded = true;
        root.isRoot = true;

        let getChildren = (node) => {
          if (!node.children) node.children = [];
          if (Array.isArray(node.groups) && node.groups.length) {
            node.groups.forEach(nodeDepartment => {
              getChildren(nodeDepartment);
              delete nodeDepartment.groups;
              nodeDepartment.nodeType = NODES_TYPES.group;
              node.children.push(nodeDepartment);
            });
            delete node.groups;
          }
          if (Array.isArray(node.buildings) && node.buildings.length) {
            node.buildings.forEach(building => {
              building.nodeType = NODES_TYPES.house;
              building.group_id = node.id;
              node.children.push(building);
            });
            delete node.buildings;
          }

          if (node.children.length === 1) {
            node.expanded = true;
          }
        };
        getChildren(root);
        return [root];
      }
    },
    methods: {
      tpl(...args) {
        let {0: node, 1: ctx, 2: parent, 4: props} = args;

        let titleClass = node.checked ? 'node-title hover-title--checked' : 'node-title';
        titleClass += node.halfcheck ? ' hover-title--half-checked' : '';

        let icon;
        let title;

        if(node.nodeType === NODES_TYPES.group){
          icon = (<feather-icon icon="LayersIcon" class="mr-2"/>);
          title = node.name;
        }else{
          icon = (<feather-icon icon="HomeIcon" class="mr-2"/>);
          title = node.address;
        }

        if(props.level === 1){
          icon = (<feather-icon icon="CompanyIcon" class="mr-2"/>);
        }

        let hoverClass = 'inline-flex items-center hover-title mr-1 ';

        return (<div class={titleClass} onClick={() => {this.selectNode(node)}}>
        {icon}
      <span class="node-name" domPropsInnerHTML={title}></span>
            </div>
        );
      },
      acceptParametersHouses() {
        let selectedHouses = this.$refs.tree.getCheckedNodes().filter(h => h.nodeType === NODES_TYPES.house).map(h => h.id);
        this.$emit('input', selectedHouses);
        this.$emit('update:danger', false);
        this.isSelectHousePopupOpen = false;
      },
      onNodeCheck(node, value){
        node.selected = value;
        this.updateGroupsSelected();
        this.reRenderTree();
      },
      updateGroupsSelected(){
        let updateSelected = (node) => {
          if(node.nodeType === NODES_TYPES.group){
            if(Array.isArray(node.children) && node.children.length){
              node.children.forEach(childNode => updateSelected(childNode));

              if(node.children.filter(c => c.checked).length){
                if(node.children.filter(c => c.checked).length === node.children.length){
                  node.selected = true;
                  node.checked = true;
                  node.halfcheck = false;
                }
                else{
                  node.checked = false;
                  node.selected = true;
                  node.halfcheck = true;
                }
              }
              else if(node.children.filter(c => c.halfcheck).length){
                node.checked = false;
                node.selected = true;
                node.halfcheck = true;
              }
              else{
                node.selected = false;
                node.halfcheck = false;
                node.checked = false;
              }
            }
          }
        };
        updateSelected(this.housesTree[0]);
      },
      onNodeSelect(event, node){},
      reRenderTree(){
        this.isShowTree = false;
        this.$nextTick(() => {
          this.isShowTree = true;
        });
      },
      selectNode(node){
        node.selected = node.checked;
        this.$refs.tree.nodeSelected(node);
        this.updateGroupsSelected();
        this.reRenderTree();
      },
      updateSelectedNodes(){
        let updateSelected = (node) => {
          if(node.nodeType === NODES_TYPES.house){
            if(this.valueX.includes(node.id)){
              node.selected = true;
              node.checked = true;
            }
            else{
              node.selected = false;
              node.checked = false;
            }
          }
          else{
            if(Array.isArray(node.children) && node.children.length){
              node.children.forEach(childNode => updateSelected(childNode));
            }
          }
        };
        updateSelected(this.housesTree[0]);
        this.updateGroupsSelected();
        this.reRenderTree();
      }
    },
    created() {
      this.houses = JSON.parse(JSON.stringify(this.$store.getters['appUser/housesGroups']));
      this.allHouses = JSON.parse(JSON.stringify(this.$store.getters['appUser/housesGroups']));
    },
    watch: {
      isSelectHousePopupOpen(){
        if(this.isSelectHousePopupOpen){
          this.updateSelectedNodes();
        }
      }
    }
  }
</script>

<style lang="scss">
  .reports-house-tree {
    .tree-node-el {
      display: flex;
      align-items: center;
    }

    .tree-expand {
      margin-right: 10px;
    }

    .node-title {
      display: flex;
      align-items: center;
    }

    .hover-title {
      background: transparent;
      padding: .25rem;
      border-radius: .5rem;
      cursor: pointer;
    }

    .inputCheck {
      top: 0px;
      margin-right: 5px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      .check {
        background: brown;
        border: 1px solid;
        top: -1px;
        left: -1px;
        bottom: -1px;
        height: unset;
        display: block;
        width: calc(100% + 2px);
        appearance: none;
      }

      &.box-checked {
        background: rgba(var(--vs-primary), 1);
        border-color: rgba(var(--vs-primary), 1);

        &::after {
          font-family: 'feather' !important;
          content: '\e83f';
          color: #fff;
          line-height: 1;
        }
      }

      &.box-halfchecked {
        background: rgba(var(--vs-warning), 1);
        border-color: rgba(var(--vs-warning), 1);

        &::after {
          font-family: 'feather' !important;
          content: '\e897';
          color: #fff;
          line-height: 1;
        }
      }
    }
  }

  .select-buildings{
    position: relative;

    &_danger{
      color: rgba(var(--app-danger), 1);
    }

    &__validation-error{
      display: inline-block;
      color: rgba(var(--app-danger), 1);
      overflow: hidden;
      transition: all .25s ease;
      border: 1px solid #eee;
      background: #fff;
      box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
      margin-top: 3px;
      font-weight: 600;
      text-transform: uppercase;
      padding: 4px;
      line-height: 1.2;
      font-size: 10px;
      border-radius: 2px;
      z-index: 100;
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translateX(-50%);
    }

    &__text-wrapper{
      text-align: center;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 10px 5px;
    }

    &__text{
      display: inline;
      text-align: center;
      cursor: pointer;
      user-select: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-decoration: none;
      border-bottom: 1px dashed transparent;

      &:hover{
        border-bottom: 1px dashed rgba(var(--app-content-color), 1);
      }


      &_empty{
        border-bottom: 1px dashed rgba(var(--app-content-color), 1);
      }
    }
  }
</style>
